import { useState, useEffect } from 'react'
import { useRouter } from "../../hooks/router";
import { sing_in, check_email_req, autoSignInSubUser } from "../../server/requests";

import ErrorMessage from '../AlertMessage/ErrorMessage'
import Loading from '../Loading/Loading'
import { NavLink } from "react-router-dom";
import { generate_id, info_device, translateWord, crypt } from "../Util/util";

export default function EmailCheck({
    setPopUpTitles, configs, setIsGuest
}) {
    const router = useRouter()

    const [email, setEmail] = useState('')
    const [password, setPassword] = useState('')
    const [validate, setValidate] = useState(false)
    const [showErrorMessage, setShowErrorMessage] = useState(false)
    const [errorMessage, setErrorMessage] = useState('')
    const [showPassword, setShowPassword] = useState(false)
    const [signingIn, setSigningIn] = useState(false)



    useEffect(() => {
        setPopUpTitles('Enter your email to register or login to your account')
    }, []);

    const onSubmit = (e) => {

        e.preventDefault();

        if (showPassword) {
            login()
        } else {
            check_email()
        }

    }

    const login = () => {
        let result

        if (localStorage.getItem('device_id')) result = localStorage.getItem('device_id')
        else {
            result = generate_id()
            localStorage.setItem('device_id', result)
        }

        let device_info = info_device()

        var body = {
            email: email,
            password: password,
            device_id: result,
            device_model: device_info.split(' ')[0],
            device_name: device_info.split(' ')[1]
        }

        if (email && password) {
            sing_in(body, res => {

                localStorage.clear()
                setIsGuest(false)
                localStorage.setItem('token', crypt('token', res))
                localStorage.setItem('root', crypt('root', JSON.stringify(body)))
                setSigningIn(true)
                autoSignInSubUser(router, null, () => setSigningIn(false))

            }, err => {
                setPassword('')
                show_and_hide_message(err)
                // if (err === "email not active") {
                //     router.push('/auth/mail-verification?m=' + err + '&type=error&mail=' + body.email)
                // } else {

                //     setShowErrorMessage(true)
                //     setErrorMessage(err)
                //     setValidate(true)
                //     setTimeout(() => {
                //         setShowErrorMessage(false)
                //     }, 3000);
                // }

            })
        } else {
            setValidate(true)
        }
    }
    const check_email = () => {
        const body = {
            email: email,
        }

        // email validation
        const re = /\S+@\S+\.\S+/;
        const valid = re.test(email);

        if (valid) {

            check_email_req(body, res => {

                console.log(res, 'res valid email')

                if (res.is_register) {
                    setShowPassword(true)

                    setPopUpTitles('Welcome back! ')
                } else {
                    router.push('/auth/message?n=verify')
                }

            }, err => {
                console.log(err, 'err')
                if (err === "email not active") {
                    router.push('/auth/mail-verification?m=' + err + '&type=error&mail=' + body.email)

                } else {


                    setEmail('')
                    show_and_hide_message(err)

                    setValidate(true)
                    setTimeout(() => {
                        setShowErrorMessage(false)
                    }, 3000);
                }

            })
        } else {
            setValidate(true)
            show_and_hide_message('Please enter a valid email address')
        }
    }

    const goToHelp = () => {

        let helpUrl = configs?.help_page.replace('{{lang}}', configs?.language.iso_code)

        window.open(helpUrl)
        // window.location.href = helpUrl

    }

    const show_and_hide_message = (message) => {
        setShowErrorMessage(true)
        setErrorMessage(message)
        setTimeout(() => {
            setShowErrorMessage(false)
        }, 3000);
    }
    if (signingIn) return <Loading />

    return (
        <>

            <ErrorMessage text={errorMessage} type={'error'} show={showErrorMessage} />

            {showPassword ?
                <>
                    <h2 className='title_pop_up'>
                        {translateWord('enter your password to login your account', 'Enter your password to login to your account.')}
                    </h2>
                    <p className='currnet_mail'>{translateWord('Email')}:{email}</p>

                </>
                : null}

            <div className="login">
                <form onSubmit={onSubmit} action="">
                    {
                        showPassword ?
                            <>
                                <label htmlFor="">{translateWord('password', 'Password')}:</label>
                                <input className={validate && !password ? 'not_valid' : ''} type="password"
                                    value={password} name={'password'} onChange={(e) => setPassword(e.target.value)} />
                                <NavLink to={'/auth/forgot-password'} className='forgot_password'> {translateWord('Forgot Password?', 'Forgot Password?')} </NavLink>
                                <button type={'submit'} className={'card_color'}>{translateWord('login', 'Login')}</button>
                            </>
                            :
                            <>
                                <label htmlFor="">{translateWord('email', 'E-Mail')}:</label>
                                <input className={validate && !email.length ? 'not_valid' : ''} type="text" value={email}
                                    name={'email'} onChange={(e) => setEmail(e.target.value)} />

                                <button type={'submit'} className={'card_color'}>{translateWord('Get started', 'Get started')}</button>
                                <NavLink to={'/auth/sign-in'} className='forgot_password'> {translateWord('sign in', 'Sign In')} </NavLink>
                            </>
                    }

                    <p>
                        {translateWord('Need help? ', 'Need help? ')}
                        <span onClick={goToHelp}>{translateWord('Go to Help', 'Go to Help')}</span>
                    </p>
                </form>
            </div>
        </>
    )
}